import axiosInstance from "@/utils/axios";
import API from "@/constant/API";

const getCardBinList = async () => {
  const res = await axiosInstance.post(API.CARD_BIN_LIST);
  return res
}

const getApplyPreview = async (data) => {
  const res = await axiosInstance.post(API.APPLY_CARD_PREVIEW, data)
  return res
}

const applyCard = async (data) => {
  const res = await axiosInstance.post(API.APPLY_CARD_ORDER, data)
  return res
}

const exportBill = async (data) => {
  return await axiosInstance.post(API.CARD_BILL_EXPORT, data)
}

const getCardApplyOrderDetail = async (data) => {
  return await axiosInstance.post(API.CARD_APPLY_ORDER_DETAIL, data)
}

const getCardTxExemptionRule = async (data) => {
  return await axiosInstance.post(API.CARD_TX_EXEMPTION_RULE, data)
}

const getCardFiatSetting = async (data) => {
  return await axiosInstance.post(API.CARD_FIAT_SETTING, data)
}
const setCardFiatSettingStatus = async (data) => {
  return await axiosInstance.post(API.CARD_FIAT_SETTING_STATUS_CHANGE, data)
}
const setCardFiatSetting = async (data) => {
  return await axiosInstance.post(API.CARD_FIAT_SETTING_CURRENCY_TOGGLE, data)
}
const getCardReissueFee = async () => {
  return await axiosInstance.post(API.CARD_REISSUE_FEE)
}

const getCardReissueTypes = async (data) => {
  return await axiosInstance.post(API.CARD_REISSUE_TYPES, data)
}

const cardReissuePreview = async (data) => {
  return await axiosInstance.post(API.CARD_REISSUE_PREVIEW, data)
}

const cardReissueApply = async (data) => {
  return await axiosInstance.post(API.CARD_REISSUE_APPLY, data)
}

const cardDeletePreview = async (data) => {
  return await axiosInstance.post(API.CARD_DELETE_PEVIEW, data)
}

const cardDeletePay = async (data) => {
  return await axiosInstance.post(API.CARD_DELETE_AND_PAY, data)
}

export { getCardBinList, getApplyPreview, applyCard, exportBill, getCardApplyOrderDetail, getCardTxExemptionRule,
  getCardFiatSetting, setCardFiatSettingStatus, setCardFiatSetting, getCardReissueFee, getCardReissueTypes, cardReissueApply,
  cardDeletePreview, cardDeletePay, cardReissuePreview
}